import { User } from 'lib-shared-types-api';
import { UserRole, userRoles } from 'lib-shared-user-role';

import { userHasRole } from '../userHasRole';

const currentUserRoleKeyPrefix = 'atLeast';

type CurrentUserRoleResult = Record<
  `${typeof currentUserRoleKeyPrefix}${Capitalize<UserRole>}`,
  boolean
>;

/**
 * Checks a user against all possible user roles and returns which roles the
 * user does and does not belong to.
 *
 * @param user The user object.
 */
export function currentUserRole(user: User): CurrentUserRoleResult {
  return userRoles.reduce(
    (roles, role) => ({
      ...roles,
      [`${currentUserRoleKeyPrefix}${role.charAt(0).toUpperCase()}${role.slice(
        1,
      )}`]: userHasRole(user, role),
    }),
    {} as CurrentUserRoleResult,
  );
}
